import { render } from "./CollapseButtonLR.vue?vue&type=template&id=0603e778&scoped=true&ts=true"
import script from "./CollapseButtonLR.vue?vue&type=script&lang=ts"
export * from "./CollapseButtonLR.vue?vue&type=script&lang=ts"

import "./CollapseButtonLR.vue?vue&type=style&index=0&id=0603e778&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\y-tosa.LOCALPSC\\repo\\seto-solan\\apps\\admin-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0603e778"]])

export default __exports__